import { useState, useCallback } from "react";
import dayjs from "dayjs";

export default function useWebsiteVisitModals({ cleanDisplay }) {
  const [contactsModalOpen, setContactsModalOpen] = useState(false);
  const [contactsVisitorId, setContactsVisitorId] = useState(null);
  const [contactsCompanyKey, setContactsCompanyKey] = useState("");
  const [contactsCompanyName, setContactsCompanyName] = useState("");
  const [contactsPageUrl, setContactsPageUrl] = useState("");

  const [pageModalOpen, setPageModalOpen] = useState(false);
  const [pageModalData, setPageModalData] = useState({
    companyName: "",
    visitDate: "",
    pages: [],
    durationSeconds: null,
  });

  const handleOpenContactsModal = useCallback(
    (selectedGroup) => {
      if (!selectedGroup?.representative?.visit_id) return;

      const rep = selectedGroup.representative;
      setContactsVisitorId(rep.visit_id);

      const accountId = cleanDisplay(rep?.visitor_account_id) || cleanDisplay(rep?.account_id);
      const companyName =
        cleanDisplay(rep?.visitor_company_name) ||
        cleanDisplay(rep?.visitor_account_name) ||
        "";
      const state = cleanDisplay(rep?.visitor_state);

      let companyKey = "";
      if (accountId) {
        companyKey = `id:${accountId}`;
      } else if (companyName && state) {
        companyKey = `name_state:${companyName.toLowerCase()}|${state.toLowerCase()}`;
      } else if (companyName) {
        companyKey = `name:${companyName.toLowerCase()}`;
      }
      setContactsCompanyKey(companyKey);

      setContactsCompanyName(companyName);
      setContactsPageUrl(cleanDisplay(rep?.page_url) || "");
      setContactsModalOpen(true);
    },
    [cleanDisplay],
  );

  const handleCloseContactsModal = useCallback(() => {
    setContactsModalOpen(false);
  }, []);

  // ✅ FIXED: uses group instead of raw row
  const handleOpenPagesModal = useCallback(
    (group) => {
      if (!group) return;

      const row = group.representative;

      const companyTitle =
        cleanDisplay(row?.visitor_company_name) ||
        cleanDisplay(row?.visitor_account_name);

      const visitDate = row?.last_seen
        ? dayjs(row.last_seen).format("YYYY-MM-DD")
        : "";

      const durationSecondsRaw =
        row?.duration_seconds != null
          ? row.duration_seconds
          : (row?.duration ?? null);

      let normalizedPages = group.pages || [];

      if ((!normalizedPages || normalizedPages.length === 0) && row?.page_url) {
        const url = cleanDisplay(row.page_url);
        if (url) {
          normalizedPages = [
            {
              url,
              last_seen: row.last_seen || null,
              duration_seconds: durationSecondsRaw,
            },
          ];
        }
      }

      setPageModalData({
        companyName: companyTitle || "Unknown company",
        visitDate,
        pages: normalizedPages || [],
        durationSeconds: durationSecondsRaw,
      });

      setPageModalOpen(true);
    },
    [cleanDisplay],
  );

  const handleClosePagesModal = useCallback(() => {
    setPageModalOpen(false);
  }, []);

  return {
    contactsModalOpen,
    contactsVisitorId,
    contactsCompanyKey,
    contactsCompanyName,
    contactsPageUrl,
    pageModalOpen,
    pageModalData,
    handleOpenContactsModal,
    handleCloseContactsModal,
    handleOpenPagesModal,
    handleClosePagesModal,
  };
}
